import {useEffect} from "react";

type MapAttributionStyleProps = {
    offset: {height: number};
};

export function MapAttributionStyle({offset}: MapAttributionStyleProps) {
    useEffect(() => {
        const styleId = "map-attribution-style";
        let styleElement = document.getElementById(styleId) as HTMLStyleElement;

        if (!styleElement) {
            styleElement = document.createElement("style");
            styleElement.id = styleId;
            document.head.appendChild(styleElement);
        }

        styleElement.textContent = `
            @supports (selector(:has(*))) {
                div :has(> a[href^="https://maps.google.com/maps"]),
                div :has(> a[href^="http://maps.google.com/maps"]),
                div :has(> .gmnoprint) {
                    bottom: ${offset.height}px !important;
                }
            }

            .gmnoprint div,
            .gm-style-cc div {
                display: none !important;
            }
        `;

        return () => {
            if (styleElement && styleElement.parentNode) {
                styleElement.parentNode.removeChild(styleElement);
            }
        };
    }, [offset.height]);

    return null;
}
